import styles from './styles.module.scss';
import Button from 'components/button';
import AccountInfo from '../account-info';
import Companies from '../companies';
import OptionalLinks from '../optional-links';
import { useRef } from 'react';
import useOnClickOutside from 'models/utils/useOnClickOutside';
import Disclaimer from '../disclaimer';
import EditFavoriteProduct from '../edit-favorite-product';
import { t } from 'i18next';
import { useMenu } from 'context/MenuContext';
import { isImpersonate, logoutImpersonate } from 'utils/impersonate';

type ProfileSettings = {
  toogleSettings() : void
}

function ProfileSettings(props : ProfileSettings) : JSX.Element {
  const {
    customConfig,
  } = useMenu();

  const profileRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(profileRef, props.toogleSettings, ['react-select']);

  const getLogoutUrl = () : string => {
    return `${process.env.REACT_APP_LOGOUT_URL}`;
  };

  const FooterButton = () : JSX.Element => {
    if(isImpersonate()) {
      return (
        <Button
          className={styles['biobar-profile-impersonate']}
          onClick={logoutImpersonate}
          text='Sair impersonate'/>
      );
    }

    return (
      <a id='biobar-logout' href={getLogoutUrl()}>
        <Button
          onClick={() : void => { location.href = getLogoutUrl(); }}
          text={t('biobar.profile.exit')}/>
      </a>
    );
  };

  return (
    <div
      ref={profileRef}
      id={styles['biobar-profile-settings']}>
      <AccountInfo/>
      <Companies {...props} />
      <EditFavoriteProduct />
      <OptionalLinks />
      <Disclaimer />
      <div className={styles['biobar-profile-button']}>
        <FooterButton />
      </div>
    </div>
  );
}

export default ProfileSettings;